var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"c-icon",class:_vm.modifier,attrs:{"role":"presentation","aria-hidden":"true"}},[_c('use',_vm._b({},'use',{ 'xlink:href': _vm.iconPath },false))])}
var staticRenderFns = []

export { render, staticRenderFns }